import gurdeepSingh_resume from '../assets/pdf/Gurdeep_Singh_Resume.pdf'
import image from '../assets/png/profile.jpg'

export const headerData = {
    name: 'Gurdeep Singh',
    title: "Full-Stack Web Developer",
    desciption:"An innovative aspiring full-stack web developer with a specialization in front-end and back-end web development. Adaptable to new technology to enhance my skills and capabilities. ",
    image: image,
    resumePdf: gurdeepSingh_resume
}
